import { Metrics } from "../../Themes/Metrics";

const styles = {
    container: {
        ...Metrics.container
    }
};

export default styles;
